import styled from 'styled-components';

import { colors } from 'styles/theme/colors';

type Props = {
  label: string;
  subLabel?: string;
  showPill?: boolean;
  pillText?: string;
  pillColors?: {
    color: string;
    borderColor: string;
    backgroundColor: string;
  };
  handleLaunch: () => void;
  disabled?: boolean;
};

export default function Launcher({ label, subLabel, showPill, pillText, handleLaunch, pillColors, disabled }: Props) {
  return (
    <Container onClick={disabled ? undefined : handleLaunch} $disabled={disabled}>
      <LabelGroup>
        <Label>
          {label}
          {showPill && <Pill $colors={pillColors}>{pillText}</Pill>}
        </Label>
        {subLabel && <SubLabel>{subLabel}</SubLabel>}
      </LabelGroup>
      <Caret fill={colors.black100} />
    </Container>
  );
}

function Caret({ fill, ...props }: React.SVGProps<SVGSVGElement> & { fill?: string }) {
  return (
    <svg width={7} height={10} viewBox='0 0 7 10' fill={fill} xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M0.570339 1.00104C0.570395 1.26657 0.675922 1.5212 0.863706 1.70892L4.16083 5.00604L0.863706 8.30317C0.68132 8.49201 0.5804 8.74492 0.582681 9.00745C0.584962 9.26997 0.690262 9.5211 0.875903 9.70674C1.06154 9.89238 1.31267 9.99768 1.57519 9.99996C1.83772 10.0022 2.09064 9.90132 2.27948 9.71894L6.28448 5.71393C6.47219 5.52617 6.57764 5.27154 6.57764 5.00604C6.57764 4.74055 6.47219 4.48592 6.28448 4.29816L2.27948 0.293154C2.13945 0.153169 1.96106 0.0578432 1.76687 0.019228C1.57267 -0.0193882 1.37139 0.00043869 1.18846 0.0762033C1.00553 0.151968 0.84917 0.28027 0.739148 0.444885C0.629127 0.609501 0.570381 0.803041 0.570339 1.00104Z' />
    </svg>
  );
}

const Container = styled.div<{ $disabled?: boolean }>`
  height: 64px;
  border: 1px solid ${(props) => (props.$disabled ? colors.black10 : colors.black25)};
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  margin-bottom: 8px;
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.$disabled ? 0.5 : 1)};
  &:hover {
    border-color: ${(props) => (props.$disabled ? colors.black10 : colors.blue100)};
  }
`;

const LabelGroup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Label = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${colors.black100};
  display: flex;
  align-items: center;
`;

const SubLabel = styled.div`
  font-size: 12px;
  font-weight: normal;
  color: ${colors.black100};
  padding-top: 8px;
`;

const Pill = styled.span<{ $colors?: { color: string; borderColor: string; backgroundColor: string } }>`
  font-size: 10px;
  color: ${(props) => props.$colors?.color};
  border: 0.5px solid ${(props) => props.$colors?.borderColor};
  background-color: ${(props) => props.$colors?.backgroundColor};
  padding: 4px 8px;
  margin-left: 8px;
  border-radius: 16px;
`;
